<template>
  <div class="view-page-container">
    <!-- <PremiumPage
      title="Event Details"
      subtitle="View schedules, descriptions, and banner"
      showBack
    >
      <template #header-actions>
        <v-btn
          depressed
          class="edit-btn px-6"
          color="var(--brand)"
          :to="'/societyadmin/event/edit/' + event.id"
        >
          <v-icon small left color="white">mdi-pencil-outline</v-icon>
          <span class="white--text">Edit Event</span>
        </v-btn>
      </template> -->

    <div>
      <!-- ── Unified Detail Card ──────────────────────── -->
      <div class="unified-detail-card">
        <div class="udc-header pb-4">
          <div class="udc-profile-top">
            <div class="udc-profile-left">
              <div class="udc-avatar-wrap" style="border-radius: 16px">
                <div
                  class="udc-placeholder"
                  style="
                    background: var(--sb-act-bg) !important;
                    color: var(--brand);
                  "
                >
                  <v-icon size="32" color="var(--brand)"
                    >mdi-calendar-star</v-icon
                  >
                </div>
              </div>
              <div class="udc-info">
                <h2 class="udc-name">{{ event.title }}</h2>
                <div class="udc-meta-row mt-2">
                  <div class="udc-meta-item">
                    <v-icon size="14" color="#0D9972"
                      >mdi-calendar-clock</v-icon
                    >
                    <span class="udc-meta-text"
                      >Starts:
                      <span class="font-weight-bold">{{
                        event.start_datetime | formatDateTime
                      }}</span></span
                    >
                  </div>
                  <span class="udc-meta-sep">|</span>
                  <div class="udc-meta-item">
                    <v-icon size="14" color="#EF4444"
                      >mdi-calendar-check</v-icon
                    >
                    <span class="udc-meta-text"
                      >Ends:
                      <span class="font-weight-bold">{{
                        event.end_datetime | formatDateTime
                      }}</span></span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="udc-profile-right">
              <button
                class="udc-back-btn"
                @click="$router.go(-1)"
                :style="{ color: buttonColor, borderColor: buttonColor }"
              >
                <v-icon size="16" class="arrow" :style="{ color: buttonColor }"
                  >mdi-arrow-left</v-icon
                >
                BACK
              </button>
            </div>
          </div>
        </div>

        <div class="udc-content-wrap">
          <!-- ── Banner Section ──────────────────── -->
          <div class="event-banner-display mb-8" v-if="event.picture_url">
            <v-img
              :src="API_BASE_URL + '/uploads/' + event.picture_url"
              class="banner-image rounded-xl elevation-2 shadow-sm cursor-pointer"
              @click="mediaDialog = true"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="var(--brand)"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>

          <!-- ── Information ──────────────────────── -->
          <div class="event-info-section">
            <div class="premium-field-label mb-4">Description</div>
            <div class="event-description-text">
              {{ event.description }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </PremiumPage> -->
    <MediaViewer v-model="mediaDialog" :items="mediaItems" :index="0" />
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import moment from "moment";
import MediaViewer from "../../common/MediaViewer.vue";

export default {
  name: "ViewEvent",
  components: { MediaViewer },
  data() {
    return {
      user: {},
      loading: false,
      serverSideErrors: {},
      event: {
        title: "",
        description: "",
        start_datetime: null,
        end_datetime: null,
        picture_url: "",
      },
      mediaDialog: false,
      API_BASE_URL: process.env.VUE_APP_API_URL,
    };
  },
  computed: {
    ...mapState("theme", ["buttonColor"]),
    mediaItems() {
      if (!this.event.picture_url) return [];
      return [
        {
          url: this.API_BASE_URL + "/uploads/" + this.event.picture_url,
          type: "image",
          name: this.event.title,
        },
      ];
    },
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getEventDetail() {
      let _self = this;
      _self.$axios
        .get("societyadmin/events/" + _self.$route.params.id)
        .then((response) => {
          let data = response.data;
          if (data.status) {
            _self.event = data.event;
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    getFormattedDate(date) {
      if (!date) return "N/A";
      return moment(Number(date)).format("DD MMM, YYYY • hh:mm A");
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getEventDetail();
  },
};
</script>

<style scoped>
.view-page-container {
  padding: 24px;
}

.banner-image {
  object-fit: contain;
  width: 50%;
}

.edit-btn {
  border-radius: 12px !important;
  font-weight: 700;
  text-transform: none;
  height: 42px !important;
}

/* ── Unified Detail Card ── */
.unified-detail-card {
  background: var(--surface);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
  border: 1px solid var(--border);
  display: flex;
  flex-direction: column;
}

/* Header section */
.udc-header {
  padding: 16px 16px 0px 16px;
  border-bottom: 1px solid var(--border);
  background: var(--surface);
}

.udc-profile-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  position: relative;
}

.udc-profile-left {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  padding-right: 100px;
}

.udc-avatar-wrap {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
  background: var(--surface2);
}
.udc-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.udc-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.udc-info {
  flex: 1;
}

.udc-name {
  font-family: "Bricolage Grotesque", sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: var(--tx);
  margin: 0;
  letter-spacing: -0.01em;
}

.udc-meta-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
}
.udc-meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
}
.udc-meta-text {
  font-size: 13.5px;
  color: var(--tx2);
  font-weight: 500;
}
.udc-meta-sep {
  color: var(--border);
  font-size: 14px;
  opacity: 0.5;
}

.udc-profile-right {
  position: absolute;
  top: 0;
  right: 0;
  flex-shrink: 0;
}

/* Back Button */
/* Back Button */
.udc-back-btn {
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px !important;
  padding: 0 14px 0 10px !important;
  font-weight: 700 !important;
  font-size: 12px !important;
  letter-spacing: 0.05em !important;
  border-radius: 8px !important;
  color: var(--btn-color) !important;
  border: 1px solid var(--btn-color) !important;
  background: var(--surface2) !important;
  height: 38px !important;
  cursor: pointer !important;
  transition: all 0.2s !important;
}

.udc-back-btn:hover {
  background: var(--surface2) !important;
  border-color: var(--btn-color) !important;
}

.arrow {
  color: var(--btn-color) !important;
}

/* Content Area */
.udc-content-wrap {
  background: var(--surface2);
  min-height: 400px;
  padding: 24px;
}

.premium-field-label {
  font-size: 12px;
  font-weight: 700;
  color: var(--tx3, #64748b);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.event-description-text {
  font-size: 15px;
  line-height: 1.7;
  color: var(--tx2);
  white-space: pre-line;
  max-width: 800px;
}

/* Responsive */
@media (max-width: 768px) {
  .udc-profile-top {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  .udc-profile-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  .udc-meta-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .udc-meta-sep {
    display: none;
  }
  .udc-content-wrap {
    padding: 16px;
  }
}

.shadow-sm {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06) !important;
}
</style>
